import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const AffiliateTermsPage: React.FC = () => {
  const pdfUrl = '/assets/pdfs/Affiliate.pdf';

  return (
    <div className="faq-page-container flex justify-center items-center h-screen bg-gray-100">
      <div className="pdf-viewer w-full max-w-4xl shadow-lg bg-white p-4 rounded-lg">
        <h1 className="text-2xl font-bold text-center mb-6">
          Affiliate Terms and Conditions
        </h1>
        <div
          className="overflow-y-auto hide-scrollbar"
          style={{
            height: '70vh',
          }}
        >
          <Worker
            workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
          >
            <Viewer fileUrl={pdfUrl} />
          </Worker>
        </div>
      </div>
    </div>
  );
};

export default AffiliateTermsPage;
